import { useState } from "react";

interface VoiceCaptureButtonProps {
  onActivate: () => void;
  isActive?: boolean;
}

export default function VoiceCaptureButton({
  onActivate,
  isActive = false,
}: VoiceCaptureButtonProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onClick={onActivate}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
        isActive
          ? "bg-blue-600 text-white shadow-md"
          : isHovered
            ? "bg-gray-200 text-gray-700"
            : "bg-gray-100 text-gray-600 hover:bg-gray-200"
      }`}
      title="Voice Capture"
    >
      {/* Microphone icon */}
      <svg
        className={`w-4 h-4 transition-colors duration-200 ${
          isActive ? "text-white" : "text-gray-600"
        }`}
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 2a3 3 0 0 1 3 3v6a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3zM19 10v1a7 7 0 0 1-14 0v-1h2v1a5 5 0 0 0 10 0v-1h2z" />
      </svg>

      {/* Text label */}
      <span className="hidden sm:inline">Voice Capture</span>

      {/* Active indicator */}
      {isActive && (
        <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
      )}
    </button>
  );
}
